<template>
  <Modal
    v-model="showModalNew"
    title="办理信息"
    :mask-closable="false"
    width="600"
    @on-ok="closeModal"
    @on-cancel="closeModal"
  >
    <div style="height: 300px;position: relative">
      <div v-if="!_.isEmpty(reason)">
        <div class="box mar-btm20">
          <div class="reason-title">办理人员</div>
          <div class="reason-value">{{reason.realName}}({{reason.userName }})</div>
          <div class="role" :style="{color:reason.roleColor,borderColor:reason.roleColor}">{{reason.role}}</div>
        </div>
        <div class="box mar-btm20">
          <div class="reason-title">操作</div>
          <div class="reason-value" :style="{color:reason.color}">{{reason.statusName}}</div>
        </div>
        <div class="box mar-btm20">
          <div class="reason-title">操作时间</div>
          <div class="reason-value">{{reason.time}}</div>
        </div>
        <div class="box mar-btm20" v-if="reason.remark">
          <div class="reason-title">取消原因</div>
          <div class="reason-value">{{reason.remark}}</div>
        </div>
      </div>
      <Spin fix v-if="detailLoading"></Spin>
    </div>

  </Modal>
</template>

<script>
  export default {
    name: 'detailModal',
    props:{
      showModal:{
        type:Boolean,
        default:false
      },
      id:null
    },
    data () {
      return {
        showModalNew:false,
        reason:{},
        detailLoading:false
      }
    },
    watch: {
      showModal () {
        this.showModalNew = JSON.parse(JSON.stringify(this.showModal))
      },
      id () {
        if (this.id) {
          this.reason = {}
          this.getDetail()
        }
      }
    },
    methods:{
      getDetail () {
        this.detailLoading = true
        this.$get(this.urlobj.getAppointmentBanliDetail(this.id)).then(res => {
          this.detailLoading = false
          var info = res.rows[0]
          this.reason = {
            realName:info.realName,
            userName:info.userName,
            status:info.status,
            statusName:handleStatus(info.status).name,
            color:handleStatus(info.status).color,
            time:this.$util.FormatDate(Number(info.dealTime), "yyyy-MM-dd HH:mm"),
            role:info.status == 4?'居民':'管理员',
            roleColor:info.status == 4?'#59bf64':'#ff7b44',
            remark:info.cancelMsg
          }
        }).catch(e => {
          this.detailLoading = false
        })
      },
      closeModal () {
        this.$emit('closeOpinion')
      }
    },
    mounted () {

    }
  }
  function handleStatus(status) {
    console.log(status)
    // 1--已预约、2--逾期未办、4--居民取消办理、8--管理员取消预约、16--待评价、32--已办结,
    switch (status) {
      case 1:
        return {
          name:'已预约',
          color:'#00d372'
        };
        break;
      case 2:
        return {
          name:'逾期未办',
          color:'#5e6d9e'
        };
        break;
      case 4:
        return {
          name:'居民取消办理',
          color:'#cfc800'
        };
        break;
      case 8:
        return {
          name:'管理员取消预约',
          color:'#cf6aff'
        };
        break;
      case 16:
        return {
          name:'已办理',
          color:'#ffaf00'
        };
        break;
      case 32:
        return {
          name:'已办结',
          color:'#8cc64e'
        };
        break
    }
  }
</script>

<style scoped>
.reason-title{
  width: 80px;
  font-size: 15px;
}
  .reason-value{
    color:#999;
    font-size: 15px;
  }
  .mar-btm20{
    margin-bottom: 20px;
    line-height: 1;
  }
  .role{
    border-radius: 10px;
    border-style: solid;
    border-width: 1px;
    height: 15px;
    line-height: 15px;
    padding: 0 10px;
    margin-left: 10px;
  }
</style>
